import { render } from "./Needs.vue?vue&type=template&id=140f6239"
import script from "./Needs.vue?vue&type=script&lang=js"
export * from "./Needs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__